export const STEPPER_STYLES = {
  "& .MuiStepLabel-root": {},
  "& .MuiStepContent-root": {
    borderColor: "#8ac7d9",
    borderLeftWidth: 3,
  },
};

export const NEW_WORKSPACE_TEXT =
  "Configure your market settings to suit your preferences";
